import { Injectable } from '@angular/core';
import { UtilizationApiService } from './utilization-api.service';

@Injectable({ providedIn: 'root' })
export class EmulatorUtilizationApiService extends UtilizationApiService {
  protected get baseUrl(): string {
    return super.baseUrl.replace('utilization', 'scheduler-emulator');
  }
}
